import { supportedLanguagesByLocaleCode } from './locales'
import { LiveLanguageCodes } from './types'

type LocaleConfig = {
  isProduction: boolean
  localeCookieDomain: string
}

let config: LocaleConfig = {
  isProduction: false,
  localeCookieDomain: '',
}

export function configureLocales(options: LocaleConfig): void {
  config = { ...config, ...options }
}

export function isProductionEnvironment(): boolean {
  return config.isProduction
}

export function getLocaleCookieDomain(): string {
  return config.localeCookieDomain
}

export const isSupportedLanguage = (
  language: string | undefined,
): language is LiveLanguageCodes => {
  if (language && language in supportedLanguagesByLocaleCode) {
    const locale = supportedLanguagesByLocaleCode[language as LiveLanguageCodes]
    if (isProductionEnvironment() && !locale.availableInProduction) {
      return false
    }
    return true
  }

  return false
}

export const shouldShowOverrideDialogue = (): boolean => {
  const OVERRIDE_QUERY_KEY = '__monzo_locale_override__'
  if (typeof window === 'undefined') {
    return false
  }
  const query = new URLSearchParams(window.location.search)
  return query.has(OVERRIDE_QUERY_KEY)
}
